import { NAIL_SUPPLY_ROUTE_NAME } from "@/libs/route-name";
import type { RouteRecordRaw } from "vue-router";

export const nailSupplyRoutes: RouteRecordRaw[] = [
  {
    path: "categories",
    name: NAIL_SUPPLY_ROUTE_NAME.CATEGORY,
    component: () => import("@/pages/nail-supply/category.vue")
  },
  {
    path: "categories/:category",
    name: NAIL_SUPPLY_ROUTE_NAME.PRODUCT,
    component: () => import("@/pages/nail-supply/product.vue")
  },
  {
    path: "cart",
    name: NAIL_SUPPLY_ROUTE_NAME.CART,
    component: () => import("@/pages/order/index.vue")
  },
  {
    path: "shipping-information",
    name: NAIL_SUPPLY_ROUTE_NAME.SHIPPING_INFORMATION,
    component: () => import("@/pages/shipping/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "shipping-information/address-saved",
    name: NAIL_SUPPLY_ROUTE_NAME.ADDRESS_SAVED,
    component: () => import("@/pages/shipping/address-saved.vue")
  },
  {
    path: "order-preview",
    name: NAIL_SUPPLY_ROUTE_NAME.ORDER_PREVIEW,
    component: () => import("@/pages/order-preview/index.vue"),
    meta: {
      requireAuth: true
    }
  },
  {
    path: "checkout",
    name: NAIL_SUPPLY_ROUTE_NAME.CHECKOUT,
    component: () => import("@/pages/checkout/index.vue"),
    meta: {
      requireAuth: true
    }
  }
];
